import { urlsWrapper } from 'config';
import { createSelector } from 'reselect';
import { commonDelete, commonGet, commonPost, commonPut } from './api';

const itemConstants = {
  SET_HOVER_ITEM: 'CADASTER_PARCELS_SET_HOVER_ITEM',
  SET_TOTAL_COUNT: 'CADASTER_PARCELS_SET_TOTAL_COUNT',
  SET_SHOW_FIELD_NAMES: 'CADASTER_PARCELS_SET_SHOW_FIELD_NAMES',
  SET_SHOW_PLOT_NUMBERS: 'CADASTER_PARCELS_SET_SHOW_PLOT_NUMBERS',
  SET_LEGAL_TITLE_FILTER: 'CADASTER_PARCELS_SET_LEGAL_TITLE_FILTER',
  SET_TOGGLE_FILTERS: 'CADASTER_PARCELS_SET_TOGGLE_FILTERS',
};

// reducer
export const cadasterParcels = (
  state = {
    hoveredItem: null,
    totalFields: 0,
    totalArea: 0,
    showFieldNames: true,
    showPlotNumbers: true,
    legalTitleFilter: null,
    isOpenFilters: false,
  },
  action
) => {
  switch (action.type) {
    case itemConstants.SET_HOVER_ITEM:
      return {
        ...state,
        hoveredItem: action.payload.hoveredItem,
        items: action.payload.items,
      };
    case itemConstants.SET_TOTAL_COUNT:
      return {
        ...state,
        totalFields: action.payload.totalFields,
        totalArea: action.payload.totalArea,
      };
    case itemConstants.SET_SHOW_FIELD_NAMES:
      return {
        ...state,
        showFieldNames: action.payload,
      };
    case itemConstants.SET_SHOW_PLOT_NUMBERS:
      return {
        ...state,
        showPlotNumbers: action.payload,
      };
    case itemConstants.SET_LEGAL_TITLE_FILTER:
      return {
        ...state,
        legalTitleFilter: action.payload,
      };
    case itemConstants.SET_TOGGLE_FILTERS:
      return {
        ...state,
        isOpenFilters: action.payload,
      };
    default:
      return state;
  }
};

export const setIsHoverItem = (payload) => ({
  type: itemConstants.SET_HOVER_ITEM,
  payload,
});

export const setTotalCount = (payload) => ({
  type: itemConstants.SET_TOTAL_COUNT,
  payload,
});

export const setShowFieldNames = (payload) => ({
  type: itemConstants.SET_SHOW_FIELD_NAMES,
  payload,
});

export const setShowPlotNumbers = (payload) => ({
  type: itemConstants.SET_SHOW_PLOT_NUMBERS,
  payload,
});

export const setLegalTitleFilter = (payload) => ({
  type: itemConstants.SET_LEGAL_TITLE_FILTER,
  payload,
});

export const setToggleCadasterFilters = (payload) => ({
  type: itemConstants.SET_TOGGLE_FILTERS,
  payload,
});

export const getHoveredCadasterItem = (state) =>
  state.cadasterParcels.hoveredItem;

export const getHoveredCadasterItems = (state) => state.cadasterParcels.items;

export const getShowFieldNames = (state) =>
  state.cadasterParcels.showFieldNames;

export const getShowPlotNumbers = (state) =>
  state.cadasterParcels.showPlotNumbers;

export const getLegalTitleFilter = (state) =>
  state.cadasterParcels.legalTitleFilter;

export const getCadasterIsOpenFilters = (state) =>
  state.cadasterParcels.isOpenFilters;

export const getHoveredCadasterInfo = createSelector(
  [
    (state) => state.cadasterParcels.totalFields,
    (state) => state.cadasterParcels.totalArea,
  ],
  (totalFields, totalArea) => ({ totalFields, totalArea })
);

export function getCadastralParcels(params) {
  return commonGet({
    url: urlsWrapper('cadastralParcels'),
    params,
  });
}

export function createCadastralParcel(data) {
  return commonPost({
    url: `${urlsWrapper('cadastralParcels')}`,
    data,
    name: 'кадастровый участок',
  });
}

export function updateCadastralParcel(parcelId, data) {
  return commonPut({
    url: `${urlsWrapper('cadastralParcels')}/${parcelId}`,
    data,
    name: 'кадастровый участок',
  });
}

export function deleteCadastralParcel(parcelId, data) {
  return commonDelete({
    url: `${urlsWrapper('cadastralParcels')}/${parcelId}`,
    data,
    name: 'кадастровый участок',
  });
}

export function getCadastralParcelsGeojson(params = {}) {
  return commonGet({
    url: `${urlsWrapper('cadastralParcels')}/geojson`,
    params,
  });
}
